import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getBearerToken } from '@features/authentication/authFunctions';



export const baseApi = createApi({
	reducerPath: 'baseApi',
	baseQuery: fetchBaseQuery({
		baseUrl: `${process.env.SHIPPINGDATA_API_URL}/`,
		prepareHeaders: async(headers) => {
			headers.set('AuthToken', getBearerToken());
			return headers;
		},
	}),
	tagTypes: [
		'allCodeReasons',
		'plantsList',
		'districtsList',
		'regionsList',
		
		'reducedOrdersReport',
		'reducedMaterialsReport',
		'redatedOrdersReport',
		'undeliveredOrdersReport',
		'shipmentStopsReport',
		'shipmentStopsTiles',

		'deliveriesMainReport',
		'deliveriesTradesDcReport',
		'deliveriesTradesDistrictReport',
		'deliveriesCustomerReport',
		'deliveriesSkuReport',
		'deliveriesSkuDcReport',
		'deliveriesSkuDistrictReport',
		
		'previewStatistics',
		'orderGpsTrack',

		'detailStatistics',
		'customerInfo',
		'orderTimeline',
		'singleOrder',

		'userData',
		'fullFilter',
	],
	endpoints: () => ({}),
});